module.exports = __webpack_public_path__ + "fonts/Open_Sans-300-cyrillic-ext5.4ebfe55.woff2";